import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Loader2, ArrowRight } from 'lucide-react';

/**
 * Email + optional referral-code form for the passwordless magic-link flow.
 * Owns ONLY rendering; all state lives in the parent so the parent can swap
 * between this and the AuthSentPanel without re-mounting.
 */
export const EmailSignInForm = ({
  mode,
  email,
  referralCode,
  submitting,
  onEmailChange,
  onReferralCodeChange,
  onSubmit,
}) => (
  <form onSubmit={onSubmit} className="space-y-4" data-testid="auth-form">
    <div>
      <Label htmlFor="email" className="text-gray-300">Email address</Label>
      <Input
        id="email"
        name="email"
        type="email"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
        placeholder="you@example.com"
        required
        autoFocus
        data-testid="auth-email-input"
        className="mt-1 bg-[#0A0A0A] border-gray-800 text-white placeholder:text-gray-500"
      />
    </div>

    {mode === 'signup' && (
      <div data-testid="auth-signup-extras">
        <Label htmlFor="referralCode" className="text-gray-300">
          Referral code <span className="text-gray-500 text-xs">(optional)</span>
        </Label>
        <Input
          id="referralCode"
          name="referralCode"
          type="text"
          value={referralCode}
          onChange={(e) => onReferralCodeChange(e.target.value)}
          placeholder="e.g. ab12cd"
          data-testid="auth-referral-input"
          className="mt-1 bg-[#0A0A0A] border-gray-800 text-white placeholder:text-gray-500"
        />
        <p className="text-xs text-gray-500 mt-1">
          Both you and your friend get{' '}
          <span className="text-[#00FF00] font-semibold">+14 days of Pro</span> when you start your trial.
        </p>
      </div>
    )}

    <Button
      type="submit"
      disabled={submitting}
      data-testid="auth-continue-btn"
      className="w-full bg-[#00FF00] text-black hover:bg-[#00DD00] font-semibold py-5"
    >
      {submitting ? (
        <Loader2 className="w-5 h-5 animate-spin" />
      ) : (
        <>
          Continue
          <ArrowRight className="w-4 h-4 ml-2" />
        </>
      )}
    </Button>
  </form>
);
